import { ValueEncoder } from 'DiscoveryEngine.TS/Utils';
import { ObjectSerializer } from 'DiscoveryEngine.TS/Serialization';


export class SamlSettingsDto implements ObjectSerializer {

	private static readonly Default_Enabled: boolean = false;

	public Enabled: boolean;
	public AppEntityId: string;
	public ProviderCertificate: string;
	public ProviderId: string;
	public ProviderLoginUrl: string;
	public ProviderLogoutUrl: string;

	constructor() {
		this.Enabled = SamlSettingsDto.Default_Enabled;
		this.AppEntityId = "";
		this.ProviderCertificate = "";
		this.ProviderId = "";
		this.ProviderLoginUrl = "";
		this.ProviderLogoutUrl = "";
	}

	public get HasAppEntityId(): boolean {
		return !!this.AppEntityId;
	}

	public get HasProviderCertificate(): boolean {
		return !!this.ProviderCertificate;
	}

	public get HasProviderId(): boolean {
		return !!this.ProviderId;
	}

	public get HasProviderLoginUrl(): boolean {
		return !!this.ProviderLoginUrl;
	}

	public get HasProviderLogoutUrl(): boolean {
		return !!this.ProviderLogoutUrl;
	}

	public Write(obj: any, context: any): void {

		obj.saml_settings = {};
		obj = obj.saml_settings;

		obj.enabled = ValueEncoder.EncodeBoolean(this.Enabled);

		if (this.HasAppEntityId) {
			obj.app_entity_id = this.AppEntityId;
		}

		if (this.HasProviderId) {
			obj.provider_id = this.ProviderId;
		}

		if (this.HasProviderCertificate) {
			obj.provider_certificate = this.ProviderCertificate;
		}

		if (this.HasProviderLoginUrl) {
			obj.provider_login_url = this.ProviderLoginUrl;
		}

		if (this.HasProviderLogoutUrl) {
			obj.provider_logout_url = this.ProviderLogoutUrl;
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.saml_settings)
			throw new Error();
		obj = obj.saml_settings;

		if (obj.enabled !== undefined) {
			this.Enabled = ValueEncoder.DecodeBoolean(obj.enabled);
		}

		if (obj.app_entity_id !== undefined) {
			this.AppEntityId = obj.app_entity_id;
		}

		if (obj.provider_id !== undefined) {
			this.ProviderId = obj.provider_id;
		}

		if (obj.provider_certificate !== undefined) {
			this.ProviderCertificate = obj.provider_certificate;
		}

		if (obj.provider_login_url !== undefined) {
			this.ProviderLoginUrl = obj.provider_login_url;
		}

		if (obj.provider_logout_url !== undefined) {
			this.ProviderLogoutUrl = obj.provider_logout_url;
		}
	}

}
